import React, { useEffect } from "react";
import * as Icons from "@wix/wix-ui-icons-common";
import {
  Box,
  Button,
  Card,
  WixDesignSystemProvider,
  MarketingPageLayout,
  MarketingPageLayoutContent,
  Page,
  Modal,
  CustomModalLayout,
  Cell,
  Loader,
} from "@wix/design-system";
import "@wix/design-system/styles.global.css";
import { ReactTagManager } from "react-gtm-ts";
import { useTranslation } from "react-i18next";
import { initAnalytics, track } from "./analytics";


const tagManagerArgs = {
  code: "GTM-WZQPMC7",
};


function App() {
  const { t } = useTranslation();
  const token = new URLSearchParams(window.location.search).get("token");
  const instance = new URLSearchParams(window.location.search).get("instance");
  const [InteractiveDemoOpen, setInteractiveDemoOpen] =
  React.useState(false);
  const [isUpgraded, setIsUpgraded] = React.useState(false);
  const [instanceData, setInstanceData] = React.useState({
    instance: {
      isFree: true,
      availablePlans: [],
      instanceId: "",
    },
  } as any);

  useEffect(() => {
    ReactTagManager.init(tagManagerArgs);
    initAnalytics();
    setInstance();
  }, []);

  function setInstance() {
    fetch("https://wix.certifiedcode.io/slots-stores/_functions/@certifiedcode/base-backend/instance", {
      headers: { Authorization: instance || "" },
    })
      .then((r) => r.json())
      .then((data) => {
        setInstanceData(data);
        setIsUpgraded(data?.instance?.isFree === false);
      })
      .catch(() => {});
  }

  const upgradeUrl = `https://memberships.certifiedcode.us/${window.location.search}`;

  if (token) {
    return (
      <WixDesignSystemProvider features={{ newColorsBranding: true }}>
        <Page height="100vh">
          <Page.Content>
            <Box height={"90vh"} direction="vertical" verticalAlign="middle">
              <Loader text={t("loading")} />
            </Box>
          </Page.Content>
        </Page>
      </WixDesignSystemProvider>
    );
  }
  const openInteractiveDemo = () => {
    setInteractiveDemoOpen(true);
  };
  return (
    
    <WixDesignSystemProvider features={{ newColorsBranding: true }}>
       {/* Modal for Interactive Demo */}
       <Modal
            isOpen={InteractiveDemoOpen}
            screen="desktop"
            shouldDisplayCloseButton={true}
            shouldCloseOnOverlayClick={true}
            onRequestClose={() => setInteractiveDemoOpen(false)}
          >
             <CustomModalLayout
              removeContentPadding={true}
              content={
                <div style={{ position: "relative", paddingBottom: "calc(56.22% + 41px)", height: 0, width: "100%" }}>
                  <iframe
                    src="https://app.arcade.software/share/MB7U9250IMl0l16mYIrE?embed&embed_mobile=inline&embed_desktop=inline&show_copy_link=true"
                    title="Slots for Stores | Getting Started"
                    frameBorder="0"
                    loading="lazy"
                    allow="clipboard-write"
                    allowFullScreen
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", colorScheme: "light" }}
                  ></iframe>
                </div>
              }
            />
          </Modal>
      <Card>
        <MarketingPageLayout
          removeImageHorizontalPadding
          removeImageVerticalPadding
          content={
            <Box height="500px" verticalAlign="middle">
              <MarketingPageLayoutContent
                title={t("ss-title")}
                content={t("ss-content")}
                actions={
                  <Box gap="SP2">
                    <Button
                      suffixIcon={<Icons.Edit />}
                      as="a"
                      href={`https://www.wix.com/editor/${instanceData?.site?.siteId}`}
                      target="_blank"
                    >
                      {t("edit-site")}
                    </Button>
                    <Button
                      suffixIcon={<Icons.PremiumFilled />}
                      skin={isUpgraded ? "premium-light" : "premium"}
                      as="a"
                      href={upgradeUrl}
                      target="_blank"
                    >
                      {isUpgraded ? t("manage-plan") : t("up-set-live")}
                    </Button>
                  </Box>
                }
              />
            </Box>
          }
        />
            <Cell span={12}> 
            <Card>
              <MarketingPageLayout
                removeImageHorizontalPadding
                removeImageVerticalPadding
                content={
                  <Box  marginTop= "-10rem" verticalAlign="middle">
                    <MarketingPageLayoutContent
                      size="medium"
                      title={t("ss-learn-title")}
                      content={t("ss-time")}
                      actions={
                        <Box marginTop="-30px">
                        <Button
                          priority="secondary" 
                          size="small"
                          skin="premium"
                          onClick={openInteractiveDemo}
                        >
                          {t("watch-video")}
                        </Button>
                      </Box>
                      }
                    />
                  </Box>
                }
              />
            </Card>
          </Cell>
      </Card>
    </WixDesignSystemProvider>
  );
}

export default App;
